// extracted by mini-css-extract-plugin
export default {"definitions":"TimeDefinitions_definitions__6sZmy","term1":"TimeDefinitions_term1__p-+XW","term":"TimeDefinitions_term__bT81O"};